import { Component } from '@angular/core';

@Component({
  selector: 'doc-page-skeleton-loader',
  templateUrl: './doc-page-skeleton-loader.component.html',
  standalone: false,
})
export class DocPageSkeletonLoaderComponent {}
